import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import type {
    ConflictingCoverableDTO,
    CoverableDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useHippoText } from '../../hooks/useHippoText';
import { useWithdrawJob } from '../../recoil/hooks/useWithdrawJob';
import { useRecoilValue } from 'recoil';
import { jobAtom } from '../../recoil/atoms/jobAtom';
import { WITHDRAWN } from '../../recoil/types/types';
import { topConfigContextAtom } from '../../recoil/atoms/topConfigContextAtom';

const ViewExistingInsuranceModal = ({
    showModal,
    closeModal,
    coverableToRemove,
    conflictingCoverable
}: {
    showModal: boolean;
    closeModal?: () => void;
    coverableToRemove: CoverableDTO;
    conflictingCoverable: ConflictingCoverableDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { withdrawJob } = useWithdrawJob();
    const jobDTO = useRecoilValue(jobAtom);
    const topConfigContext = useRecoilValue(topConfigContextAtom);
    const mitTopDKHostURL = topConfigContext?.siteConfig?.scope?.includes('mit.')
        ? ''
        : `//${topConfigContext?.siteConfig?.sisterHost ?? ''}`;

    const goToPolicyDetailsPage = (): void => {
        const subPath = '/policy-details-page/mine-forsikringer/';
        const flavour =
            conflictingCoverable.flavourName
                ?.replace('ø', 'oe')
                .replaceAll(' ', '-')
                .toLocaleLowerCase() ?? '';
        const policyNumber: string = conflictingCoverable.policyNumber ?? '';
        const fixedId = conflictingCoverable.fixedId ?? '';
        window.location.href = `${mitTopDKHostURL}${subPath}${flavour}/?policeNummer=${policyNumber}&id=${fixedId}`;
    };

    return (
        <ModalOverlay isOpen={showModal} onDismiss={closeModal}>
            <ModalDialog closeIconHandler={closeModal}>
                <div className="u-spacing-inset-l">
                    <div className="u-spacing-inset-l--stretch-max">
                        <h4 className="u-spacing-stack-sm">
                            {getHippoText('DSS-VIEW-INSURANCE-MODAL-HEADER')}
                        </h4>
                        <p className="u-spacing-stack-sm">
                            {getHippoText('DSS-VIEW-INSURANCE-MODAL-SUBHEADER', {
                                coverable_information: conflictingCoverable.name ?? ''
                            })}
                        </p>
                    </div>
                    <Button
                        onClick={() => {
                            if (jobDTO.jobStatus !== WITHDRAWN) void withdrawJob();
                            goToPolicyDetailsPage();
                        }}
                    >
                        {getHippoText('DSS-VIEW-INSURANCE-MODAL-BUTTON')}
                    </Button>
                </div>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default ViewExistingInsuranceModal;
